<template>
    <List v-if="stateOptions.length">
        <ListItem
            v-for="stateOption of stateOptions"
            :key="stateOption.value"
            :label="stateOption.label"
            :disabled="disabled || stateOption.disabled"
            class="list-item"
            @click="$emit('update:deploymentState', stateOption.value)"
        />
    </List>
    <List v-else>
        <ListItem
            label="Geen geschikte toestand gevonden"
            :disabled="true"
            class="list-item"
        />
    </List>
</template>

<script lang="ts">
    import List from '@/components/Branding/List.vue';
    import ListItem from '@/components/Branding/ListItem.vue';
    import {Deployment, Template, OrganisationDeploymentState, Shift, Organisation} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import {OrganisationUtil} from '@/util/organisation';
    import {NumberSelectInputOption} from '@cquential/ui';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordCell from '@/components/Planbord/PlanbordCell.vue';

    @Component({
        components: {
            List,
            ListItem,
        },
        emits: [
            'update:deploymentState',
        ],
    })
    export default class DeploymentCellContextMenuState extends Vue {
        @Prop({required: true}) public cells!: PlanbordCell[];
        @Prop({required: true}) public shifts!: Record<number, Shift>;
        @Prop({required: true}) public organisation!: Organisation;
        @Prop({type: Boolean}) public disabled!: boolean;

        public get deployments(): Deployment[] {
            return this.cells.map((cell: PlanbordCell): Deployment[] => {
                return cell.deployments;
            }).flat();
        }

        public get stateOptions(): NumberSelectInputOption[] {
            if (!this.organisation) {
                return [];
            }
            const options: NumberSelectInputOption[] = [];

            for (const deployment of this.deployments) {
                const template: Template = this.shifts[deployment.shiftId].template!;
                if (deployment.companyId !== null || (!template.hasAllStates && !template.hasLeaveState)) {
                    options.push({
                        value: this.defaultDeploymentState!.deploymentStateId,
                        label: this.defaultDeploymentState!.caption,
                    });

                    return options;
                }
            }

            const deploymentDates: Date[] = this.deployments.map((deployment: Deployment): Date => {
                return deployment.date;
            });

            if (deploymentDates.length === 0) {
                return options;
            }
            const minDate: Date = Dates.Utils.min(...deploymentDates);
            const maxDate: Date = Dates.Utils.min(...deploymentDates);
            const organisationDeploymentStates: Record<number, OrganisationDeploymentState> = this.organisation.organisationDeploymentStates;

            // Loop over data to build options for stat
            for (const stateId in organisationDeploymentStates) {
                if (organisationDeploymentStates[stateId].beginDate <= minDate && organisationDeploymentStates[stateId].endDate >= maxDate) {
                    options.push({
                        label: organisationDeploymentStates[stateId].caption,
                        value: organisationDeploymentStates[stateId].deploymentStateId,
                    });
                }
            }

            return options;
        }

        public get defaultDeploymentState(): OrganisationDeploymentState | null {
            if (!this.organisation) {
                return null;
            }

            return this.organisation.organisationDeploymentStates[OrganisationUtil.getDefaultState(this.organisation.organisationDeploymentStates)];
        }
    }
</script>

<style lang="scss" scoped>
    .list-item {
        min-width: 150px;
    }
</style>
